<div class="verify-patient-registration hidden">
    <a class="btn btn-link btn-icon btn-icon--left btn-back hidden" [routerLink]="['/login']">
        {{ 'Go to login page' | translate }}
    </a>
    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="card--box__header--info">
                    <div class="card--box__header__title">
                        {{ 'Verify patient registration' | translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="card-block card--box__block">
            <div class="row">
                <div class="col-xs-12">
                    <ng-container *ngIf="registerSuccess">
                        <h2>{{ 'Verify success' | translate }}</h2>
                    </ng-container>
                    <ng-container *ngIf="errorMessage">
                        <h2>{{ errorMessage | translate }}</h2>
                    </ng-container>
                </div>
            </div>
            <div class="row" *ngIf="registerSuccess">
                <div class="col-xs-4 offset-xs-8">
                    <button class="btn btn-primary pull-right" [disabled]="!srURL" (click)="gotoSR()">
                        {{ 'Open Self-report directly' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>